module.exports = __webpack_public_path__ + "img/tag-check.7f9c7e16.png";